import { render, staticRenderFns } from "./c_Creator_EditQuests_Item_introVideo.vue?vue&type=template&id=3bb2485a&scoped=true&"
import script from "./c_Creator_EditQuests_Item_introVideo.vue?vue&type=script&lang=js&"
export * from "./c_Creator_EditQuests_Item_introVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2485a",
  null
  
)

export default component.exports